__turbopack_context__.v({
  "className": "roboto_343e9718-module__vsznoW__className",
  "variable": "roboto_343e9718-module__vsznoW__variable",
});
